import axios from 'axios';
import {cacheAdapterEnhancer, throttleAdapterEnhancer} from 'axios-extensions';

function initialState() {
    return {
        http: axios.create({
            baseURL: '/',
            headers: {
                'Cache-Control': 'no-cache',
            },
            // headers: conf.headers,

            // disable the default cache
            adapter: cacheAdapterEnhancer(throttleAdapterEnhancer(axios.defaults.adapter, {threshold: 10 * 1000}), {enabledByDefault: true}),
            catch: function (error) {
            }
        })
    }
}

const mutations = {
    SET_HTTP(state, http) {
        state.http = http;
    },

}

export default {
    state: initialState,
    mutations
}